import { Badge } from 'antd';
import { observer } from 'mobx-react-lite';

import { EAccountStatus } from '../../core/account-status';

type AccountStatusLabelProps = {
  status?: EAccountStatus;
};

export const AccountStatusLabel = observer(
  ({ status }: AccountStatusLabelProps) => {
    if (status == undefined) return null;

    switch (status) {
      case EAccountStatus.new:
        return (
          <Badge
            status="processing"
            text="Новый"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      case EAccountStatus.active:
        return (
          <Badge
            status="success"
            text="Активен"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      case EAccountStatus.blocked:
        return (
          <Badge
            status="error"
            text="Заблокирован"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      default:
        return (
          <Badge
            status="default"
            text="Неизвестный статус"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
    }
  }
);
